(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/interaction/scComment/template', '<div></div>\n' + '');
}]);
})();